import { fromJS, List } from 'immutable';
import * as actionTypes from '../actions/messageDialogActionTypes';
import * as messageDialogTypes from '../constants/messageDialogTypes';
import { MessageDialogMessage } from '../utils/messageDialogUtils';

const initialState = fromJS({
  messageList: [],
});

const session = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.MESSAGE_DIALOG_ADD_ERROR:
      return state
        .update('messageList', list => list.push(
          new MessageDialogMessage(messageDialogTypes.MESSAGE_DIALOG_TYPE_ERROR, action.message)
        ));
    case actionTypes.MESSAGE_DIALOG_ADD_INFO:
      return state
        .update('messageList', list => list.push(
          new MessageDialogMessage(messageDialogTypes.MESSAGE_DIALOG_TYPE_INFO, action.message)
        ));
    case actionTypes.MESSAGE_DIALOG_DISMISS_ALL:
      return state
        .set('messageList', new List());
    case actionTypes.MESSAGE_DIALOG_ERROR_INTL:
      return state
      .update('messageList', list => list.push(
        new MessageDialogMessage(messageDialogTypes.MESSAGE_DIALOG_TYPE_ERROR_INTL, action.message)
      ));
    case actionTypes.MESSAGE_DIALOG_INFO_INTL:
      return state
      .update('messageList', list => list.push(
        new MessageDialogMessage(messageDialogTypes.MESSAGE_DIALOG_TYPE_INFO_INTL, action.message)
      ));
    case actionTypes.MESSAGE_DISCLAIMER:
      return state
        .update('messageList', list => list.push(
         new MessageDialogMessage(messageDialogTypes.MESSAGE_DIALOG_TYPE_DISCLAIMER, action.message)
        ));
    default:
      return state;
  }
};

export default session;
